<script setup lang="ts">
import { useWinnersData } from '~/composables/useStates/useWinnersData';
import type { TStandardImageKeys } from 'assets/data/branding-library';
import type { TWinnersCategory } from '~/interfaces/winners/winnersInterfaces';

const { hotGames, mostLikedGames, mostPopularGames } = useWinnersData();

const tabs = computed<ReadonlyArray<TWinnersCategory>>(() =>
  [
    {
      key: 'hot-games',
      data: hotGames.value?.map((hGame) => hGame.game),
      icon: 'hotGames' as TStandardImageKeys,
    },
    {
      key: 'most-popular',
      data: mostPopularGames.value,
      icon: 'mostPopular' as TStandardImageKeys,
    },
    {
      key: 'most-liked',
      data: mostLikedGames.value,
      icon: 'mostLiked' as TStandardImageKeys,
    },
  ].filter((tab) => tab.data?.length),
);
</script>

<template>
  <WinnersCategoryTabs :tabs="tabs" />
  <WinnersCategoryPanels :tabs="tabs" />
</template>
